var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Reveal } from '@progress/kendo-react-animation';
/**
 * The GridColumnMenuItemContent that will be used inside the Grid ColumnMenu.
 */
var GridColumnMenuItemContent = /** @class */ (function (_super) {
    __extends(GridColumnMenuItemContent, _super);
    function GridColumnMenuItemContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    GridColumnMenuItemContent.prototype.render = function () {
        return (React.createElement("div", { className: 'k-columnmenu-item-content' },
            React.createElement(Reveal, { style: { position: 'relative', display: 'block' } }, this.props.show ? this.props.children : null)));
    };
    return GridColumnMenuItemContent;
}(React.Component));
export { GridColumnMenuItemContent };
//# sourceMappingURL=GridColumnMenuItemContent.js.map